// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__2LqHg","header":"Section_header__AmdIp","title":"Section_title__ydLMv"};